/* assets/ShopifyFormatMoney.js
   JPY-safe formatter: ¥, no decimals, proper thousands, resilient to bad inputs.
*/
(function () {
  // Reuse existing object if present
  var Shopify = (window.Shopify = window.Shopify || {});

  // Default: Japan site → Yen, no decimals
  // NOTE: This is a literal token string. It's fine in a .js file.
  Shopify.money_format = '¥{{amount_no_decimals}}';

  Shopify.formatMoney = function (cents, format) {
    // Normalize "cents" input
    if (typeof cents === 'string') {
      // strip non-digits (keep leading minus if any)
      cents = cents.replace(/[^\d-]/g, '');
    }
    var formatString = format || Shopify.money_format;

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = placeholderRegex.exec(formatString);
    // Never crash if format is malformed
    var key = match ? match[1] : 'amount_no_decimals';

    function def(opt, d) {
      return typeof opt === 'undefined' ? d : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = def(precision, 2);
      thousands = def(thousands, ',');
      decimal = def(decimal, '.');

      if (isNaN(number) || number == null) return '0';

      // keep sign separate
      var negative = Number(number) < 0;
      number = Math.abs(Number(number));

      var raw = (number / 100).toFixed(precision);
      var parts = raw.split('.');
      // ✅ IMPORTANT: '$1', not a currency symbol. This preserves the digit.
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return (negative ? '-' : '') + dollars + centsPart;
    }

    var value;
    switch (key) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        // Safe default for JPY
        value = formatWithDelimiters(cents, 0);
    }

    return formatString.replace(placeholderRegex, value);
  };

  Shopify.getPriceTaxSuffix = function () {
    return (
      window.theme && window.theme.strings && window.theme.strings.priceTaxSuffix
        ? window.theme.strings.priceTaxSuffix
        : ''
    );
  };

  Shopify.formatPrice = function (cents, format, showTaxSuffix) {
    var taxSuffix = showTaxSuffix === false ? '' : Shopify.getPriceTaxSuffix();
    return Shopify.formatMoney(cents, format) + taxSuffix;
  };
})();
